import classnames from 'classnames';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
	addProductToCompare,
	removeProductFromCompare,
} from '../../../actions/lister-actions';
import TRANSLATIONS from './translations@default.json';

export const CompareButton = ({ classes, sku, brand }) => {
	const { categoryId, comparedProducts } = useSelector((state) => state);
	const { CustomCategoriesEnabled } = useSelector(
		(state) => state.experimentSwitches
	);

	const dispatch = useDispatch();

	// return nothing if brand is excluded from compare functionality
	if (['dyson'].indexOf(brand?.toLowerCase()) > -1) {
		return null;
	}

	const isCategoryComparedLimitReached = () => {
		const comparedProductsWithinCategory = comparedProducts.filter(
			(item) => item.category === categoryId
		).length;

		return comparedProductsWithinCategory > 2;
	};

	const addOrRemoveForCompare = (event) => {
		// eslint-disable-next-line no-unused-expressions
		window.CompareSystem?.addOrRemoveProductForCompare(
			sku,
			categoryId,
			'',
			event.target
		);
	};

	const handleAddToCompare = (event) => {
		// prevent product from being added to compare if there's already 3 products in the compare bar
		if (isCategoryComparedLimitReached() === false) {
			dispatch(addProductToCompare(sku, categoryId));
		}

		addOrRemoveForCompare(event);
	};

	const handleRemoveProductFromCompare = (event) => {
		dispatch(removeProductFromCompare(sku, categoryId));
		addOrRemoveForCompare(event);
	};

	// check if product is already compared
	const productIsCompared = Boolean(
		comparedProducts?.find((item) => item.sku === sku)
	);

	if (!sku || typeof categoryId !== 'number') {
		return null;
	}

	return (
		<button
			type="button"
			className={classnames(
				classes,
				'product-card__compare-button inline-flex cta btn items-center justify-center w-full',
				{
					'cta-secondary btn-secondary xl:ml-2': CustomCategoriesEnabled,
					'cta-tertiary btn-tertiary':
						!CustomCategoriesEnabled && !productIsCompared,
					'product-card__compare-button--active cta-secondary btn-secondary border-gray-30': productIsCompared,
					'product-card__compare-button--inactive': !productIsCompared,
					// check if there are 3 compared products with the current category id
					'product-card__compare-button--maximum': isCategoryComparedLimitReached(),
				}
			)}
			onClick={(event) =>
				productIsCompared
					? handleRemoveProductFromCompare(event)
					: handleAddToCompare(event)
			}>
			<i
				className={classnames('ico mr-2 inline-flex text-lg leading-none', {
					'ico-tick': productIsCompared,
					'ico-compare': !productIsCompared,
				})}
			/>
			{productIsCompared ? TRANSLATIONS.active : TRANSLATIONS.inactive}
		</button>
	);
};

export default CompareButton;
